import { QBoxGroup } from "./QBoxGroup";

export class QBoxGroupList {
  constructor() {
    this.fBoxGroupList = null;
  }

  InitBoxGroupList() {
    if (!this.fBoxGroupList) {
      this.fBoxGroupList = [];
    }

    this.fBoxGroupList.length = 0;
  }

  AddPolySet(layout, polySet) {
    var boxGroup = new QBoxGroup();
    boxGroup.SetLayout(layout);
    var color = polySet.GetColor();
    boxGroup.SetColor(color);
    var numPoly = polySet.GetNumPolys();
    for (var i = 0; i < numPoly; i++) {
      var poly = polySet.GetPoly(i);
      boxGroup.AddPoly(poly);
    }

    if (!this.fBoxGroupList) {
      this.fBoxGroupList = [];
    }

    this.fBoxGroupList.push(boxGroup);
  }

  UpdateBoxGroups(parentPanel) {
    if (!this.fBoxGroupList) {
      return;
    }

    var nGroups = this.fBoxGroupList.length;
    for (var i = 0; i < nGroups; i++) {
      var boxGroup = this.fBoxGroupList[i];

      // What about layer. What do we do?
      //        boxGroup.SetLayer( );
      boxGroup.UpdateBoxGroupAsElement(parentPanel);
      parentPanel.PushElement(boxGroup);
    }
  }
}
